import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { AdminCentrePage } from './admin-centre';
import { FormalQuotationsPage } from './formal-quotations';
import { ContentApprovalPage } from './public-pages';
import './styles.css';

const ACCOUNT_SERVICES_URL = 'https://my.sousamurray.co.uk/account/services';
const PUBLIC_SITES_URL = 'https://sousamurray.co.uk/sites';

function ExternalRedirect({ to }: { to: string }) {
  React.useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return <main style={{ minHeight: '100vh', display: 'grid', placeItems: 'center', fontFamily: 'system-ui, sans-serif' }}><p>Returning to Sousa Murray…</p></main>;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* The Sites host is now an application host, not a public website. */}
        <Route path="/" element={<ExternalRedirect to={ACCOUNT_SERVICES_URL} />} />

        {/* Genuine Sites workspace routes retained. */}
        <Route path="/admin-centre" element={<AdminCentrePage />} />
        <Route path="/admin-centre/quotations" element={<FormalQuotationsPage />} />
        <Route path="/content-approval" element={<ContentApprovalPage />} />

        {/* Public discovery, quotations, plans, templates, help and legal now live on Sousa Murray. */}
        <Route path="*" element={<ExternalRedirect to={PUBLIC_SITES_URL} />} />
      </Routes>
    </BrowserRouter>
  );
}

createRoot(document.getElementById('root')!).render(<React.StrictMode><App /></React.StrictMode>);
